import React from "react";
import {
  FiCamera,
  FiVideo,
  FiGrid,
  FiEdit3,
  FiPrinter,
  FiCheck,
  FiFileText,
  FiFeather,
  FiGift,
} from "react-icons/fi";
import { TbGavel, TbBug } from "react-icons/tb";
import { ALL_SERVICES } from "constants/services";

// Ported from beleef-services-frontend components/onboarding/ServiceSelect.js
const SERVICE_ICONS = {
  photo: FiCamera,
  video: FiVideo,
  floorplan: FiGrid,
  floorplanRedraw: FiGrid,
  edit: FiEdit3,
  print: FiPrinter,
  auction: TbGavel,
  buildingPest: TbBug,
  strata: FiFileText,
  styling: FiFeather,
  gifting: FiGift,
};

const ServiceSelect = ({ value = [], onChange, error }) => {
  const handleToggle = (serviceValue) => {
    if (value.includes(serviceValue)) {
      onChange(value.filter((v) => v !== serviceValue));
    } else {
      onChange([...value, serviceValue]);
    }
  };

  const renderOption = (service) => {
    const isSelected = value.includes(service.value);
    const Icon = SERVICE_ICONS[service.value];

    const indicatorBase =
      "flex-shrink-0 w-5 h-5 border flex items-center justify-center rounded-md";
    const indicatorState = isSelected
      ? "bg-white border-white"
      : "border-mediumgray";

    return (
      <label
        key={service.value}
        className={`flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-colors ${
          isSelected
            ? "bg-black border-black text-white"
            : "border-mediumgray hover:border-darkgray"
        }`}
      >
        <input
          type="checkbox"
          className="sr-only"
          checked={isSelected}
          onChange={() => handleToggle(service.value)}
        />

        <span className={`${indicatorBase} ${indicatorState}`}>
          {isSelected && <FiCheck className="w-3.5 h-3.5 text-black" />}
        </span>

        {Icon && <Icon className="w-4 h-4 flex-shrink-0" />}
        <span className="text-sm font-medium">{service.label}</span>
      </label>
    );
  };

  return (
    <div className="space-y-3">
      <p className="text-sm text-darkergray">Select all that apply</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ALL_SERVICES.map((service) => renderOption(service))}
      </div>

      {error && <p className="form-error-message mt-2">{error}</p>}
    </div>
  );
};

export default ServiceSelect;
